import type { RetakerMode } from '../constants-types/ManualRetakerTypes';

let windowRef: Window | null = null;

function clearRef() {
  windowRef = null;
}

function close(): void {
  if (!windowRef) {
    return;
  }

  windowRef.close();
  clearRef();
}

function focus(): void {
  if (windowRef) {
    windowRef.focus();
  }
}

function open(url: string | URL, target?: string | undefined, features?: string | undefined): void {
  if (windowRef) close();

  windowRef = window.open(url, target, features);

  focus();
}

function postMessageToWindow(type: string, target: string, mode?: RetakerMode): void {
  if (windowRef) {
    windowRef.window.postMessage(
      {
        type,
        mode,
      },
      target,
    );
  }
}

export { open, close, postMessageToWindow };
